import { c as _c } from "react/compiler-runtime";
import { IcoForbid40, IcoSparkles16 } from '@onefootprint/icons';
import { useTranslation } from 'react-i18next';
export const EmptyState = () => {
  const $ = _c(12);
  const {
    t
  } = useTranslation("investigations");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="w-9 h-9 rounded-full bg-neutral-inverted shadow-[0_0_0_3px_rgba(0,0,0,0.1)] flex items-center justify-center"><IcoSparkles16 color="quinary" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== t) {
    t1 = t(_temp);
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <p className="text-heading-4 font-bold text-primary">{t1}</p>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t(_temp2);
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <p className="text-body-2 text-tertiary">{t3}</p>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t2 || $[10] !== t4) {
    t5 = <div className="flex items-center justify-center h-full min-h-[320px] px-4 md:px-0"><div className="flex flex-col items-center gap-6 text-center max-w-[400px]">{t0}<div className="flex flex-col items-center gap-2">{t2}{t4}</div></div></div>;
    $[9] = t2;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};
export const LoadingState = () => {
  const $ = _c(7);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="h-7 w-2/5 bg-secondary rounded mb-6" />;
    t1 = <div className="h-16 w-full bg-secondary/60 rounded-md mb-8" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="space-y-2.5 mb-10"><div className="h-3 w-full bg-secondary rounded" /><div className="h-3 w-full bg-secondary rounded" /><div className="h-3 w-11/12 bg-secondary rounded" /><div className="h-3 w-3/4 bg-secondary rounded" /></div>;
    t3 = <div className="h-5 w-1/4 bg-secondary rounded mb-4" />;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="space-y-2.5 mb-10"><div className="h-3 w-1/2 bg-secondary rounded" /><div className="h-3 w-2/5 bg-secondary rounded" /><div className="h-3 w-3/5 bg-secondary rounded" /><div className="h-3 w-2/4 bg-secondary rounded" /></div>;
    t5 = <div className="h-5 w-1/3 bg-secondary rounded mb-4" />;
    $[4] = t4;
    $[5] = t5;
  } else {
    t4 = $[4];
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="flex-1 overflow-hidden"><div className="py-8 px-4 md:px-16 max-w-(--main-content-max-width) mx-auto w-full animate-pulse">{t0}{t1}{t2}{t3}{t4}{t5}<div className="space-y-2.5"><div className="h-3 w-3/5 bg-secondary rounded" /><div className="h-3 w-1/2 bg-secondary rounded" /><div className="h-3 w-2/5 bg-secondary rounded" /></div></div></div>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  return t6;
};
type PermissionErrorStateProps = {
  description?: string;
};
export const PermissionErrorState = t0 => {
  const $ = _c(15);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    description
  } = t1;
  const {
    t
  } = useTranslation("investigations");
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <IcoForbid40 color="tertiary" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t) {
    t3 = t(_temp3);
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <p className="text-heading-4 font-bold text-primary">{t3}</p>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== description || $[8] !== t) {
    t5 = description ?? t(_temp4);
    $[7] = description;
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t5) {
    t6 = <p className="text-body-2 text-tertiary">{t5}</p>;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t4 || $[13] !== t6) {
    t7 = <div className="flex items-center justify-center h-full min-h-[320px] px-4 md:px-0"><div className="flex flex-col items-center gap-6 text-center max-w-[400px]">{t2}<div className="flex flex-col items-center gap-2">{t4}{t6}</div></div></div>;
    $[12] = t4;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
};
function _temp($) {
  return $.blocksPanel.emptyState.title;
}
function _temp2($_0) {
  return $_0.blocksPanel.emptyState.description;
}
function _temp3($) {
  return $.blocksPanel.permissionError.title;
}
function _temp4($_0) {
  return $_0.blocksPanel.permissionError.description;
}